import EventBus from '@/eventBus'

const spellcheckerPlugin = (store) => {
  store.subscribeAction({
    after: (action) => {
      if (action.type === 'spellchecker/spellcheckerSuccessAction') {
        // Update canvas for short answer and match pairs
        EventBus.$emit('eventShowQuizTypeAnswer')
        EventBus.$emit('match-pairs-change')
      }
    },
  })
}

export default spellcheckerPlugin
